export enum EParkingType {
  good = 'good',
  bad = 'bad',
  // Used by the project configurator v2 only.
  private = 'private',
  unknown = 'unknown',
}
